import { useMutation, useQueryClient } from 'react-query';
import {
  toggleBettieProfilePictureVisibility,
  type ToggleBettieProfilePictureVisibilityBody,
  type ToggleBettieProfilePictureVisibilityResponse
} from '../../services/bettieProfileService';

export function useToggleBettieProfileVisibility() {
  const queryClient = useQueryClient();
  return useMutation<
    ToggleBettieProfilePictureVisibilityResponse,
    Error,
    { chatRoomId: string; body: ToggleBettieProfilePictureVisibilityBody }
  >(({ chatRoomId, body }) => toggleBettieProfilePictureVisibility(chatRoomId, body), {
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries(['bettieChatRoomPictures', variables.chatRoomId]);
    }
  });
}
